export const categories = [
  {
    id: 'entertainment',
    name: '娱乐八卦',
    slug: 'yule-bagua',
    description: '明星动态、影视综艺、圈内秘闻，第一手娱乐资讯速递',
    color: 'bg-primary-100',
    tagColor: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20neon%20city%20night%20life%20street%20photography%20with%20warm%20amber%20and%20coral%20lights%2C%20blurred%20crowd%20silhouettes%2C%20entertainment%20district%20atmosphere%2C%20editorial%20style%2C%20high%20contrast%20warm%20tones&width=800&height=600&seq=cat-entertainment&orientation=landscape',
  },
  {
    id: 'social',
    name: '社会奇闻',
    slug: 'shehui-qiwen',
    description: '猎奇社会百态、奇人异事、不可思议的真实故事',
    color: 'bg-accent-100',
    tagColor: 'bg-accent-500',
    image: 'https://readdy.ai/api/search-image?query=Surreal%20urban%20street%20scene%20with%20unexpected%20elements%2C%20warm%20sunset%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20cinematic%20composition%2C%20warm%20amber%20and%20earth%20tones&width=800&height=600&seq=cat-social&orientation=landscape',
  },
  {
    id: 'celebrity',
    name: '明星爆料',
    slug: 'mingxing-baoliao',
    description: '独家爆料、明星花边、不为人知的圈内真相',
    color: 'bg-secondary-100',
    tagColor: 'bg-secondary-500',
    image: 'https://readdy.ai/api/search-image?query=Glamorous%20red%20carpet%20event%20spotlight%20scene%2C%20silhouette%20of%20celebrity%20figure%20with%20camera%20flashes%2C%20warm%20golden%20and%20coral%20lighting%2C%20luxurious%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=cat-celebrity&orientation=landscape',
  },
  {
    id: 'curious',
    name: '猎奇趣闻',
    slug: 'lieqi-quwen',
    description: '世界各地的奇葩趣闻、冷门知识、未解之谜',
    color: 'bg-background-200',
    tagColor: 'bg-foreground-500',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20artifacts%20and%20curiosities%20arranged%20on%20warm%20wooden%20surface%2C%20soft%20museum%20lighting%2C%20warm%20amber%20and%20earth%20tones%2C%20editorial%20still%20life%20photography%2C%20intriguing%20composition&width=800&height=600&seq=cat-curious&orientation=landscape',
  },
  {
    id: 'meme',
    name: '网络热梗',
    slug: 'wangluo-regeng',
    description: '全网最火的梗图、段子、流行语，解压必备',
    color: 'bg-primary-50',
    tagColor: 'bg-primary-400',
    image: 'https://readdy.ai/api/search-image?query=Playful%20colorful%20illustration%20of%20social%20media%20icons%20and%20speech%20bubbles%20floating%20in%20warm%20gradient%20space%2C%20cheerful%20and%20energetic%20mood%2C%20coral%20and%20amber%20color%20palette%2C%20modern%20digital%20art%20style&width=800&height=600&seq=cat-meme&orientation=landscape',
  },
  {
    id: 'decompress',
    name: '解压谈资',
    slug: 'jieya-tanzi',
    description: '轻松幽默的解压内容，缓解压力的最佳读物',
    color: 'bg-accent-50',
    tagColor: 'bg-accent-400',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20warm%20indoor%20scene%20with%20soft%20blankets%2C%20steaming%20tea%20cup%2C%20warm%20ambient%20lighting%2C%20peaceful%20and%20relaxing%20atmosphere%2C%20coral%20and%20cream%20color%20palette%2C%20lifestyle%20editorial%20photography&width=800&height=600&seq=cat-decompress&orientation=landscape',
  },
];

export const getCategoryBySlug = (slug: string) => categories.find((c) => c.slug === slug);
export const getCategoryById = (id: string) => categories.find((c) => c.id === id);